module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl1-75.ac526d7e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl1-75.png
// module id = 3581
// module chunks = 11